import type { ColumnType } from 'antd/es/table';

import { ActionDropdown } from './ActionDropdown';
import type { ActionItem } from './ActionDropdown';

export interface ActionColumnConfig<T = unknown> {
  getActions: (record: T) => (ActionItem | { type: 'divider' })[];
  width?: number;
  align?: 'left' | 'center' | 'right';
  title?: string;
  fixed?: 'left' | 'right';
}

export function createActionColumn<T = unknown>(
  config: ActionColumnConfig<T>,
): ColumnType<T> {
  return {
    title: config.title || 'Actions',
    key: 'actions',
    width: config.width || 80,
    align: config.align || 'right',
    fixed: config.fixed,
    render: (_, record) => (
      <ActionDropdown actions={config.getActions(record)} />
    ),
  };
}

export default createActionColumn;
